import { type Middleware } from '@reduxjs/toolkit';
import { dismissItem } from '#/user/slice';
import { storeItem } from '#/shared/utils/storage';
import { DISMISSED_ITEMS_STORAGE_KEY } from '#/shared/constants';

/**
 * Persists selected pieces of Redux state to local storage so they're retained
 * across app sessions
 *
 * This middleware is intended for more complex state shapes where consumers
 * only depend on a subset of the data. By handling persistence here, we avoid
 * forcing components to subscribe to the entire state slice, which can lead
 * to unnecessary re-renders
 *
 * For simple or primitive values, prefer writing to local storage directly
 * within the relevant hook or component instead of using this middleware
 */
const localStorageMiddleware: Middleware = store => next => action => {
  const result = next(action);

  if (dismissItem.match(action)) {
    storeItem(
      DISMISSED_ITEMS_STORAGE_KEY,
      store.getState().user.dismissedItems
    );
  }

  return result;
};

export default localStorageMiddleware;
